import React, { useEffect, useState } from 'react';
import { useTypedSelector } from '../../../Hooks/useTypedSelector';
import EmptyCart from '../Checkout.EmptyCart';
import Cart from '../Checkout.Cart';
import CheckoutStepContainer from '../CheckoutStepContainer';
import Input from '../../Inputs/Input';
import TextArea from '../../Inputs/TextArea';
import { translate } from '../../../Services/translation';
import { CartState } from '../../../Reducers/Cart.reducer';
import {
  submitOrder,
  setOrderNote as setOrderNoteAction,
} from '../../../Actions/Checkout.action';
import { useDispatch } from 'react-redux';
import useDebouncedOnChange from '../../../Hooks/useDebouncedOnChange';
import CheckoutScreenConfirmation from './Checkout.ScreenConfirmation';

const CheckoutStoreScreenContainer = () => {
  const dispatch = useDispatch();
  const cart = useTypedSelector<CartState>((state) => state.cart);
  const checkout = useTypedSelector((state) => state.checkout);
  const { checkoutIsSubmitting, storeScreenSuccess, payload } = checkout;
  const { redirectUrl } = payload;
  const [orderRows] = useState(cart?.orderRows);
  const [stepContainerList, setStepContainerList] = useState([]);
  const hasOrderRows = orderRows && Object.keys(orderRows).length > 0;

  const [comments, setOrderNote] = useDebouncedOnChange('', () =>
    dispatch(setOrderNoteAction(comments))
  );

  const [email, setEmail] = useState<String>();
  const [message, setMessage] = useState<String>();
  const [reference, setReference] = useState<String>();

  const [ready, setReady] = useState(false);
  useEffect(() => setReady(true), []);

  const numProducts = hasOrderRows
    ? Object.values(cart.orderRows).length
    : 0;

  // Empty cart render
  if (numProducts <= 0) {
    return (
      <div className="bg-gray-100 px-0 py-6 md:py-8 lg:py-10">
        <EmptyCart />
      </div>
    );
  }

  if (storeScreenSuccess) {
    return (
      <div className="bg-gray-100 px-0 py-6 md:py-8 lg:py-10">
        <CheckoutScreenConfirmation />
      </div>
    );
  }

  return (
    ready && (
      <div className="bg-gray-100 px-0 py-6 md:py-8 lg:py-10">
        <div className="lg:container px-0">
          <Cart />
          <CheckoutStepContainer
            label={translate('checkout.submit-order')}
            stepKey="customerInfo"
            showContent={true}
            stepComplete={false}
            setStepContainerList={setStepContainerList}
            stepContainerList={stepContainerList}
          >
            <p className="pb-3 text-xl leading-normal text-gray-700">
              {translate('checkout.call-personel')}
            </p>
            <div className="flex flex-col gap-4">
              <Input
                label={translate('checkout.store-email')}
                onChange={(e) => setEmail(e.target.value)}
                inputSize="xlarge"
                placeholder={translate('checkout.email')}
              />
              <Input
                label={translate('checkout.store-reference')}
                onChange={(e) => setReference(e.target.value)}
                inputSize="xlarge"
                placeholder={translate('checkout.reference')}
              />
              <TextArea
                label={translate('checkout.customer-support')}
                placeholder={translate('checkout.customer-message')}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button
                className="btn btn--black btn--xlarge w-full uppercase"
                disabled={!email || checkoutIsSubmitting}
                onClick={() => {
                  dispatch(submitOrder(email, message, reference));
                }}
                type="submit"
              >
                {translate('checkout.submit-order.store')}
              </button>
            </div>
          </CheckoutStepContainer>
        </div>
      </div>
    )
  );
};

export default CheckoutStoreScreenContainer;
